<template>
  <div class="form-check-radio" @click="handleClick(label)">
    <label :for="cbId" class="form-check-label">
        <slot></slot>
    </label>
  </div>
</template>
<script>
  export default {
    name: 'base-radio',
    props: {
      label: [String, Number],
      disabled: [Boolean, String],
      value: [String, Boolean],
      inline: Boolean
    },
    data () {
      return {
        cbId: ''
      }
    },
    computed: {
      model: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      },
      inlineClass () {
        if (this.inline) {
          return `radio-inline`
        }
        return ''
      }
    },
    created () {
      this.cbId = Math.random().toString(16).slice(2)
    },
    methods: {
      handleClick () {
        console.warn(this);
        // this.model.set(this.value)
      }
    }

  }
</script>
<style>

/* .form-check-radio {
  display: inline-block;
  justify-content: space-around;
} */

.form-check-label {
  border-radius: 5px;
  padding: 5px !important;
  border: 1px solid  #000;
  text-transform: none !important;
}
  </style>